enum CommissionApplication {
  ONCE = 'once',
  EACHDAY = 'eachday',
}

export { CommissionApplication }
